import React, { useState, useEffect, useRef } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useSelector } from "react-redux";
import { MultiSelect } from "primereact/multiselect";
import LoadingOverlay from "react-loading-overlay-ts";
import { dsbpConstant } from "./constant";
import warning from "../../assets/images/warning.svg";
import "./index.scss";
import { textFieldMaxLength } from "../../constants/index";
import { CharacterLimit } from "../common/CharacterLimit/CharacterLimit";
import CommonAutocomplete from "../../Utils/CommonAutocomplete";
import { AutoComplete } from "primereact/autocomplete";
import { Calendar } from "primereact/calendar";
import CalendarIcon from "../common/CalendarIcon/CalendarIcon";
import { truncateDropdownValues, changeDateFormat, formatIntoDatePicker } from "../../utils";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import ControlledInput from "../common/ControlledInput";
import { shellOwnerMistmach, notLockedPMPMessage, poaTriggeredMessage, invalidPmpMessage, updateValidPmpsSelected, invalidRecreatePOAMessage } from "./utils";
import { CIC_DEPENDENT, NOT_NEEDED, YES, actionDialogObj  } from "../../Utils/constants";
import MassUpdateCICMappingTable, { PmpMessage } from "./MassUpdateCICMappingTable";
import { alphanumericPattern } from "../../constants/regex";

import _ from "lodash";const DsbpActionDialog = ({ 
  actionHeader,
  actionDialog,
  setActionDialog,
  selected,
  massUpdateCICMappingSelected,
  actionNameObject,
  onActionSubmit,
  aiseList,
  assemblyMechanismList,
  rowData,
  headerName,
  CDPTPageData,
  IQData,
  RDTData,
  GABriefData,
  updateDropDownData,
  handleNewGaBrief,
  isSubmitEnable,
  submittedData,
  setSubmittedData,
  pmpData,
  clonedDependencyMappingData,
  loader,
  projectData,
  ownersList,
  setPageEdited,
  pageEdited,
  dropdownDataForLayoutAndDesign,
  handleReset,
  waveDetails,
  dropdownMIData,
  dropdownInitiateIDData,
  dropdownAwmProjectIdData,
}) => {
  const NULL = "null";
  const {
    Obsolete, 
    Release, 
    RecreatePOA, 
    CreatePOAA,
    AddtoProject,
    MassCICMapping,
    MassUpdate,
    Save,
    Submit,
    UpdateSave}= actionDialogObj;
  
  // const [packageName, setPackageName] = useState("");
  const [groupName, setGroupName] = useState("");
  const [aiseName, setAISEName] = useState("");
  const [assemblyMechanismChange, setAssemblyMechanismChange] = useState("");
  const [ownerChange, setOwnerChange] = useState("");
  const [bioside, setBioside] = useState("");
  const [sellable, setSellable] = useState("");
  const [formData, setFormData] = useState({});
  const [cicMatrixName, setCicMatrixName] = useState("");
  const [CDPT, setCDPT] = useState([]);
  const [IQ, setIQ] = useState([]);
  const [RDT, setRDT] = useState([]);
  const [GABrief, setGABrief] = useState([]);
  const [groupNameError, setGroupNameError] = useState("");
  const [lockedData, setLockedData] = useState([]);
  const [notLockedData, setNotLockedData] = useState([]);
  const [ownerMisMatch, setOwnerMisMatch] = useState(false);
  const [width, setWidth] = useState(0);
  const [isInputEmpty, setIsInputEmpty] = useState(true);
  const [showOwnerErrorPopup, setShowOwnerErrorPopup] = useState(false);
  const [filteredAssignees, setFilteredAssignees] = useState(null);
  const [massCICUpdate, setMassCICUpdate] = useState({
    action: MassCICMapping,
    cicNeeded: "",
    supportingPMPLayout: NULL,
    supportingPMPDesign: NULL,
    otherReference: "",
    gaBrief: "",
    validPmpsSelected: [],
    invalidPmpsSelected: [],
    affectedNonSelectedPmps: []
  });
  const [updatedDropdownDataForLayoutAndDesign, setUpdatedDropdownDataForLayoutAndDesign] =
    useState([]);

  const [selectedWaveDetail, setSelectedWaveDetail] = useState(null);
  const [submitWaveDetail, setSubmitWaveDetail] = useState(null);
  const [waveName, setWaveName] = useState(null);
  const [waveNameError, setWaveNameError] = useState("");
  const [EstStartDate, setEstStartDate] = useState(null);
  const [EstAWPrinterDate, setEstAWPrinterDate] = useState(null);
  const [TPOAOwner, setTPOAOwner] = useState(null);
  const textFieldMaxLengthWave = 30;

  const dropdownRef = useRef(null);
  const {
    cicNeeded,
    supportingPMPLayout,
    supportingPMPDesign,
    otherReference,
    gaBrief,
    validPmpsSelected,
    invalidPmpsSelected,
  } = massCICUpdate;

  let updatedData = actionNameObject?.filter((data) => data.header === actionHeader);
  
  const completeSearchAssignee = (event) => {
    // Timeout to emulate a network connection
    setTimeout(() => {
      let _filteredaAssignees;

      if (!event.query.trim().length) {
        _filteredaAssignees = [...ownersList];
      } else {
        _filteredaAssignees = ownersList.filter((objAssignee) => { 
          return objAssignee.Person
            .toLowerCase()
            .startsWith(event.query.toLowerCase());
        });
      }

      setFilteredAssignees(_filteredaAssignees);
    }, 250);
  };

  useEffect(()=>{
    let affectedPmpsArray = [];
    if(cicNeeded === CIC_DEPENDENT || cicNeeded === NOT_NEEDED){
      
      const filteredNotYesCicNeeded = _.cloneDeep(pmpData)?.filter((obj)=>obj.AWM_CIC_Needed === CIC_DEPENDENT || obj.AWM_CIC_Needed === NOT_NEEDED)
      
      validPmpsSelected.forEach((obj)=>{
        filteredNotYesCicNeeded?.forEach((item) => {
          if (
            item.AWM_Supporting_PMP_Layout === obj.DSBP_PMP_PIMaterialNumber &&
            item.AWM_Supporting_PMP_Design === obj.DSBP_PMP_PIMaterialNumber
          ) {            
              item.AWM_Supporting_PMP_Design = "";
              item.AWM_Supporting_PMP_Layout = "";
              affectedPmpsArray.push(item)
          } else if (
            item.AWM_Supporting_PMP_Layout === obj.DSBP_PMP_PIMaterialNumber ||
            item.AWM_Supporting_PMP_Design === obj.DSBP_PMP_PIMaterialNumber
          ) {
            if (item.AWM_Supporting_PMP_Design === obj.DSBP_PMP_PIMaterialNumber) {
              item.AWM_Supporting_PMP_Design = "";
              affectedPmpsArray.push(item)
            }
            if (item.AWM_Supporting_PMP_Layout === obj.DSBP_PMP_PIMaterialNumber) {
              item.AWM_Supporting_PMP_Layout = "";
              affectedPmpsArray.push(item)
            }
          }
        });
      })
    }
    setMassCICUpdate(prevState => ({
      ...prevState,
      affectedNonSelectedPmps: affectedPmpsArray,
    }));
  },[cicNeeded])

  useEffect(() => {
    if(updatedData && updatedData[0]?.value === "Mass Update CIC Mapping"){
      let validPmps = [];
      let invalidPmps = [];
      massUpdateCICMappingSelected?.forEach((obj) => {
        if (
          obj?.Copy_XML_Request_Status?.toLowerCase() === dsbpConstant?.xml_awaiting_response ||
          obj?.AWM_CIC_Matrix_Requested1 === "Yes" ||
          obj?.AWM_CIC_Requested === "Yes"
        ) {
          invalidPmps.push(obj);
        } else {
          validPmps.push(obj);
        }
      });
      setMassCICUpdate({
        ...massCICUpdate,
        validPmpsSelected: validPmps,
        invalidPmpsSelected: invalidPmps,
      });
    }
  }, [massUpdateCICMappingSelected]);

  useEffect(() => {
    setTimeout(() => {
      if (dropdownRef?.current) {
        setWidth(dropdownRef?.current?.offsetWidth);
      }
    }, 500);
  }, []);

  const optionsList = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
  ];

  const { selectedProject } = useSelector((state) => state.ProjectSetupReducer);
  const poaColumns = [
    { field: "RTA_POANumber", header: "POA Number" },
    { field: "RTA_POADescription", header: "POA Description" },
    { field: "DSBP_PMP_PIMaterialNumber", header: "PMP Number" },
    { field: "DSBP_PMP_PIMaterialDescription", header: "PMP Description" },
    { field: "Wave_Name", header: "Wave Name" },
  ];

  let filterTheCICRequestedPMP = pmpData?.filter((ele) => ele.AWM_CIC_Matrix_Requested1 === "Yes");
  const awmCICMatrixArray =
    filterTheCICRequestedPMP &&
    filterTheCICRequestedPMP?.length &&
    filterTheCICRequestedPMP?.map((item) => item.AWM_CIC_Matrix);
  let uniqueSetOfGroupNamesObject, uniqueSetOfGroupNames;
  if (awmCICMatrixArray && awmCICMatrixArray.length) {
    uniqueSetOfGroupNamesObject = new Set(awmCICMatrixArray);
    uniqueSetOfGroupNames = [...uniqueSetOfGroupNamesObject];
  }

  const handleAiseChange = (e) => {
    setAISEName(e.target.value);
    setFormData({
      ...formData,
      AWM_AISE: e.target.value,
    });
  };

  const handleAssemblyMechanismChange = (e) => {
    setAssemblyMechanismChange(e.target.value);
    setFormData({
      ...formData,
      AWM_AssemblyMechanism: e.target.value,
    });
  };

  const handleOwnerChange = (e) => {
    setOwnerChange(e.target.value);
    if (e.target.value) {
      if (!ownersList?.some((item) => item?.Person?.includes(e?.target?.value?.Person))) {
        setOwnerMisMatch(true);
      } else {
        setOwnerMisMatch(false);
      }
    } else if (e.target.value === "" || e.target.value === null) {
      setOwnerMisMatch(true);
    } else {
      setOwnerMisMatch(false);
    }

    setFormData({
      ...formData,
      Owner: e.target.value,
    });
  };

  const handleWaveActionClick = (eventKey, event) => {
    const selectedWave = waveDetails?.find((wave) => wave?.Wave_ID === eventKey);
    setSelectedWaveDetail(selectedWave);
    setSubmitWaveDetail(selectedWave);
    setEstStartDate(null);
    setEstAWPrinterDate(null);  
    setTPOAOwner(null);
    // clear any typed name when switching waves (to show current selection)
    setWaveName(selectedWave?.Wave_Name || "");
  }

  const handleBiosideChange = (e) => {
    setBioside(e.target.value);
    setFormData({ ...formData, AWM_Biocide: e.target.value });
  };

  const handleWaveNameChange = (e) => {
    // allow only characters that do not match our invalid pattern
    if (!alphanumericPattern.test(e.target.value)) {
      // always update the state even when value is empty string
      setWaveName(e.target.value);
      setSubmitWaveDetail({ ...submitWaveDetail, Wave_Name: e.target.value });
    }
  };
  const handleSellableChange = (e) => {
    setSellable(e.target.value);
    setFormData({ ...formData, AWM_Sellable: e.target.value });
  };

  const handleGroupName = (e) => {
    setGroupName(e.target.value);
    setFormData({
      ...formData,
      AWM_GroupPMP: e.target.value,
    });
  };

  // const handlePackageName = (e) => {
  //   setPackageName(e.target.value);
  //   setFormData({
  //     ...formData,
  //     POAPackageName: e.target.value,
  //   });
  // };

  // validate wave name uniqueness whenever it changes or the list updates
  useEffect(() => { 
    // On first load, if waveName is blank/null/empty, set error message
    if (waveName === null || waveName === "" || waveName === undefined) {
      setWaveNameError("Please enter a wave name.");
      return;
    }
    const normalized = waveName.trim().toLowerCase();
    const exists = waveDetails?.some(
      (w) => w?.Wave_Name?.trim().toLowerCase() === normalized
    );
    if (
      exists &&
      (
        !selectedWaveDetail ||
        selectedWaveDetail?.Wave_Name?.trim().toLowerCase() !== normalized
      )
    ) {
      setWaveNameError("Wave name must be unique");
    } else {
      setWaveNameError("");
    }
  }, [waveName, waveDetails, selectedWaveDetail]);

  const handleCicMatrixName = (e) => {
    let matrixName = e.target.value;
    setCicMatrixName(matrixName);

    if (!uniqueSetOfGroupNames?.includes(matrixName)) {
      setGroupNameError("");
      setFormData({
        ...formData,
        AWM_CICMatrix: e.target.value,
      });
    } else {
      setFormData({});
      setGroupNameError(
        "CIC Matrix with the same name already exists. Please enter a different name."
      );
    }
  };
  const optionArray = [
    { code: YES, name: YES },
    { code: CIC_DEPENDENT, name: CIC_DEPENDENT },
    { code: NOT_NEEDED, name: NOT_NEEDED },
  ];
  const handleClose = (e) => {
    setActionDialog(false);
    // if (pageEdited) {
    //   setPageEdited(true);
    // }
    // this block will make sure is page is altered then
    // setPageEdited will be done true
    if(headerName === "Dependency Mapping") {
      handleReset();
      setSubmittedData([]);
    }
  };
  if (headerName !== "Dependency Mapping") {
    if (rowData) {
      selected = [rowData];
    }
    // else if (
    //   (updatedData && updatedData[0]?.value !== "Create POAA") ||
    //   updatedData[0]?.value !== "Add to Project"
    // ) {
    //   selected = selected.filter(
    //     (item) => item.AWM_AddedToProject === "Yes" && item.AWM_AWJStatus !== "Complete"
    //   );
    // }
  } else {
    if (updatedData && updatedData[0]?.value === "Group items into CIC Matrix") {
      selected = selected?.filter(
        (item) =>
          (item.AWM_CIC_Needed === YES || item.AWM_CIC_Needed === "") &&
          //commented the below code as part of 3319 and 3341 defect
          // (item.AWM_CIC_Matrix_Requested === "" || item.AWM_CIC_Matrix_Requested1 === "") &&
          item.AWM_CIC_Matrix_Requested1 === "" &&
          item.AWM_CIC_Requested === "" &&
          item.AWM_CIC_Matrix === ""
      );
    } else if (updatedData && updatedData[0]?.value === dsbpConstant.requestCICandCICMatrix) {
      const groupedData = pmpData?.reduce((result, item) => {
        const key = item.AWM_CIC_Matrix;
        if (!result[key]) {
          result[key] = [];
        }
        result[key].push(item);
        return result;
      }, {});

      // Grouping same cic matrix
      const groupedArray = Object.keys(groupedData)
        .map((key) => {
          if (key.trim() === "") {
            return null;
          } else {
            return {
              AWM_CIC_Matrix: key,
              items: groupedData[key],
            };
          }
        })
        .filter((item) => item !== null); // Filter out null items if any empty keys were encountered

      const filteredGroupArray = groupedArray.filter((group) => {
        return selected.some(
          (selectedItem) => selectedItem.AWM_CIC_Matrix === group.AWM_CIC_Matrix
        );
      });

      // Merged grouping cic matrix and selected data toghether
      const flattenedArray = new Set([...filteredGroupArray, ...selected])

      // const flattenedArray = filteredGroupArray.reduce((result, group) => {
      //   const uniqueSet = new Set(result);
      //   group?.items?.forEach((item) => uniqueSet.add(item));
      //   selected?.forEach((item) => uniqueSet.add(item));
      //   result = [...uniqueSet];
      //   return result;
      // }, []);

      const updatedSelectionData = flattenedArray.length > 0 ? flattenedArray : selected;

      selected = updatedSelectionData?.filter(
        (item) =>
          item.AWM_CIC_Needed === YES &&
          item.AWM_CIC_Requested !== "Yes" &&
          //commented as part of 3319 and 3341 defects
          // (item.AWM_CIC_Matrix_Requested === "" || item.AWM_CIC_Matrix_Requested1 === "") === "" &&
          item.AWM_CIC_Matrix_Requested1 === "" &&
          item.AWM_CIC_Requested === "" &&
          item.AWM_CIC_Matrix_Requested1 !== "Yes"
      );

      selected = selected?.filter((item) => {
        if (item.FullKit_Condition_Checking_Page?.length > 1) {
          if (
            (item.FullKit_Condition_Checking_Page?.[1]?.CICMatrix_FullKit_Satisfied === "Yes" ||
              item.FullKit_Condition_Checking_Page?.[0]?.CICMatrix_FullKit_Satisfied === "Yes") &&
            (item?.FullKit_Condition_Checking_Page?.[1]?.CIC_FullKit_Satisfied === "Yes" ||
              item?.FullKit_Condition_Checking_Page?.[0]?.CIC_FullKit_Satisfied === "Yes")
          ) {
            return item;
          }
        } else {
          if (
            item.FullKit_Condition_Checking_Page?.[1]?.CICMatrix_FullKit_Satisfied === "Yes" ||
            item.FullKit_Condition_Checking_Page?.[0]?.CICMatrix_FullKit_Satisfied === "Yes" ||
            item?.FullKit_Condition_Checking_Page?.[1]?.CIC_FullKit_Satisfied === "Yes" ||
            item?.FullKit_Condition_Checking_Page?.[0]?.CIC_FullKit_Satisfied === "Yes"
          ) {
            return item;
          }
        }
      });
    }
  }

  const addedToProjectRows = selected?.filter(
    (item) => item.AWM_AddedToProject === "Yes" && item.AWM_AWJStatus !== "Complete"
  );
  useEffect(() => {
    if (actionHeader !== "Dependency Mapping" && updatedData?.length && selected) {
      const firstUpdatedValue = updatedData[0]?.value;
      //cheeck locked and not locked data based on below logic for both poaa creatieon and add to project
      if (firstUpdatedValue === CreatePOAA) {
        {
          /* 2952 changes -filtering out to find out owners mismatch */
        }
        const owners = selected?.reduce((acc, item) => {
          acc[item.Owner] = acc[item.Owner] ? [...acc[item.Owner], item] : [item];
          return acc;
        }, {});

        const uniqueOwners = Object.keys(owners);
        const isMultipleOwners = uniqueOwners.length > 1;

        if (isMultipleOwners) {
          setShowOwnerErrorPopup(true);
          return; // Stop execution here if multiple owners are selected
        } else {
          setShowOwnerErrorPopup(false);
        }

        const locked = selected.filter(
          (item) =>
            item.DSBP_PMP_AWReadinessGateStatus === "LOCKED" &&
            item.AWM_POARequested !== "Yes" &&
            item.RTA_POANumber === "" &&
            item?.IsCFKPending !== true &&
            (item.POAStatus === "" ||
              item.POAStatus === "Create Failed" ||
              (item.AWM_POARequested === "No" && item.POARejectionReason !== ""))
        );

        const notLocked = selected.filter(
          (item) =>
            item.DSBP_PMP_AWReadinessGateStatus !== "LOCKED" ||
            item.AWM_POARequested === "Yes" ||
            item.RTA_POANumber !== "" ||
            item?.IsCFKPending === true ||
            (item.POAStatus !== "" &&
              item.POAStatus !== "Create Failed" &&
              (item.AWM_POARequested !== "No" || item.POARejectionReason === ""))
        );

        setLockedData((prevLockedData) =>
          JSON.stringify(prevLockedData) !== JSON.stringify(locked) ? locked : prevLockedData
        );
        setNotLockedData((prevNotLockedData) =>
          JSON.stringify(prevNotLockedData) !== JSON.stringify(notLocked)
            ? notLocked
            : prevNotLockedData
        );
      } else if (firstUpdatedValue === AddtoProject) {
        const locked = selected.filter(
          (item) =>
            item.DSBP_PMP_AWReadinessGateStatus === "LOCKED" &&
            item.AWM_AddedToProject !== "Yes" &&
            item.RTA_POANumber === ""
        );

        const notLocked = selected.filter(
          (item) =>
            item.AWM_POARequested === "Yes" ||
            item.RTA_POANumber !== "" ||
            item.POAStatus === "Awaiting Response" ||
            item.DSBP_PMP_AWReadinessGateStatus !== "LOCKED" ||
            item.AWM_AddedToProject === "Yes" ||
            (item.RTA_POANumber === "" && item.AWM_CICNeeded === YES)
        );

        setLockedData((prevLockedData) =>
          JSON.stringify(prevLockedData) !== JSON.stringify(locked) ? locked : prevLockedData
        );
        setNotLockedData((prevNotLockedData) =>
          JSON.stringify(prevNotLockedData) !== JSON.stringify(notLocked)
            ? notLocked
            : prevNotLockedData
        );
      } else if (firstUpdatedValue === RecreatePOA) {
        const owners = selected?.reduce((acc, item) => {
          acc[item.Owner] = acc[item.Owner] ? [...acc[item.Owner], item] : [item];
          return acc;
        }, {});
        const uniqueOwners = Object.keys(owners);
        const isMultipleOwners = uniqueOwners.length > 1;

        if (isMultipleOwners) {
          setShowOwnerErrorPopup(true);
          return; // Stop execution here if multiple owners are selected
        } else {
          setShowOwnerErrorPopup(false);
        }

        let locked =[];
        let notLocked=[];
        
        selected.map(
          (item) => {
            if(item.RTA_RTAPOAStatus?.toLowerCase() === Obsolete?.toLowerCase() || item.RTA_RTAPOAStatus?.toLowerCase() === Release?.toLowerCase()){
              locked.push(item)
            } else {
              notLocked.push(item);
            }
          }
        );

        setLockedData((prevLockedData) =>
          JSON.stringify(prevLockedData) !== JSON.stringify(locked) ? locked : prevLockedData
        );
        setNotLockedData((prevNotLockedData) =>
          JSON.stringify(prevNotLockedData) !== JSON.stringify(notLocked)
            ? notLocked
            : prevNotLockedData
        );
      }
    }
  }, [actionHeader, updatedData, selected]);

  useEffect(() => {
    setIsInputEmpty(
      headerName === "Dependency Mapping"
        ? !cicMatrixName?.trim()
        : updatedData && updatedData[0]?.value === MassUpdate
        ? ownerMisMatch
        : !groupName?.trim()
    );
  }, [ownerMisMatch, cicMatrixName, groupName, updatedData]);

  const disableMassSave =
    (cicNeeded === "" && otherReference === "" && gaBrief === "") ||
    (otherReference?.length < 8 && otherReference?.length !== 0)
      ? true
      : false;
  const footerContent = (
    <>
    {updatedData && updatedData[0]?.value === "Group items into CIC Matrix" && <PmpMessage  message={dsbpConstant?.groupCICMatrixMessage} className="error-massage" iconClassName="error-icon" />}
    <div>
      <Button variant="secondary" onClick={handleClose}>
        {/* 2952 changes -changing the label when owerns mismatch */}
        {showOwnerErrorPopup
          ? "OK"
          : (updatedData && updatedData[0]?.value === AddtoProject) || rowData
          ? "No"
          : "Cancel"}
      </Button>
      {/* 2952 changes -hiding  yes button when owerns mismatch */}
      {!showOwnerErrorPopup && (
        <Button
          //enable the button only for locked data lenght is greater than zero
          disabled={
            (
              (updatedData && updatedData[0]?.value === CreatePOAA|| updatedData[0]?.value === RecreatePOA) ||
              updatedData?.[0]?.value === AddtoProject
                ? (lockedData?.length === 0 || waveName?.length === 0 || !!waveNameError)// Enable only if lockedData has items
                : rowData
                ? false
                : updatedData[0]?.value === MassCICMapping
                ? (selected?.length === 0 || disableMassSave) // Disable if selected is empty OR disableMassSave is true
                : updatedData && updatedData[0]?.value === dsbpConstant?.requestCICandCICMatrix
                ? selected?.length === 0
                : Object.keys(formData ?? {}).length === 0 || isInputEmpty 
            )
          }
          onClick={() =>
            updatedData && updatedData[0]?.value === CreatePOAA
              ? onActionSubmit(CreatePOAA, lockedData,submitWaveDetail)
              : updatedData[0]?.value === RecreatePOA
              ? onActionSubmit(RecreatePOA, lockedData,submitWaveDetail)
              : (updatedData && updatedData[0]?.value === AddtoProject) || rowData
              ? // ? onActionSubmit("AddToProject", selected)
                onActionSubmit(AddtoProject, lockedData,submitWaveDetail)
              : updatedData && updatedData[0]?.value === dsbpConstant.requestCICandCICMatrix
              ? onActionSubmit("RequestCIC_CICMatrix", selected)
              : updatedData && updatedData[0]?.value === MassCICMapping
              ? onActionSubmit(massCICUpdate, selected)
              : onActionSubmit(formData, selected)
          }
        >
          {updatedData && updatedData[0]?.value === MassUpdate
            ? Save
            :updatedData && updatedData[0]?.value === RecreatePOA
            ? Submit
            : updatedData && updatedData[0]?.value === MassCICMapping
            ?  UpdateSave
            : (updatedData && updatedData[0]?.value === AddtoProject) || rowData
            ? YES
            : Save}
        </Button>
      )}
    </div>
    </>
  );

  const handleCICMassUpdate = (e) => {
    const { name, value } = e.target;

    if (name === "cicNeeded") {
      setMassCICUpdate((prevState) => ({
        ...prevState,
        cicNeeded: value,
        supportingPMPLayout: NULL,
        supportingPMPDesign: NULL,
        otherReference: "",
        validPmpsSelected: updateValidPmpsSelected(
          prevState?.validPmpsSelected,
          name,
          value,
          clonedDependencyMappingData,
          RDTData,
          CDPTPageData,
          IQData
        ),
      }));
      // Extract the material numbers from the validPmpsSelected array
      const materialNumbers = validPmpsSelected?.map((obj) => obj.DSBP_PMP_PIMaterialNumber);
      // Filter out DSBP_PMP_PIMaterialNumber that are present in the materialNumbers array
      const filteredArray = dropdownDataForLayoutAndDesign.filter(
        (placeholder) => !materialNumbers?.includes(placeholder)
      );
      setUpdatedDropdownDataForLayoutAndDesign(filteredArray);
    } else { 

        let MaterialIDMU = null;
        let InitiativeIDMU = null;
        let AWMProjectIDMU = null;

      if (name === "supportingPMPLayout" || name === "supportingPMPDesign" ) { 
        const indexMU = updatedDropdownDataForLayoutAndDesign?.indexOf(value);
        MaterialIDMU = dropdownMIData[indexMU];
        InitiativeIDMU = dropdownInitiateIDData[indexMU];
        AWMProjectIDMU = dropdownAwmProjectIdData[indexMU];
      }

      setMassCICUpdate((prevState) => ({
        ...prevState,
        [name]: value,
        validPmpsSelected: updateValidPmpsSelected(
          prevState?.validPmpsSelected,
          name,
          value,
          clonedDependencyMappingData,
          RDTData,
          CDPTPageData,
          IQData,
          MaterialIDMU,
          InitiativeIDMU,
          AWMProjectIDMU
        ),
      }));
    }
  };

  return (
    <div className="card flex justify-content-center dsbp-action-dialog">
      {/* 2952 changes -hiding the header when owerns mismatch */}
      <Dialog
        header={!showOwnerErrorPopup && actionHeader}
        visible={actionDialog}
        onHide={() => {
          // if (pageEdited) {
          //   setPageEdited(true);
          //   // if page edited then on click of hide again setting setPageEdited
          //   // earlier which we setted as false when click yes,
          //   // but since we are closing with save/submit
          //   // then if we reopen then warning should come again until save clciked
          // }
          // setActionDialog(false);
          handleClose();
        }}
        footer={footerContent}
        id="actionDialog"
        className={updatedData && updatedData[0]?.value ===RecreatePOA?"actionpopup":""}
      >
      {!showOwnerErrorPopup && (
      updatedData && ( updatedData[0]?.value === AddtoProject || updatedData[0]?.value === CreatePOAA || updatedData[0]?.value === RecreatePOA) && actionHeader !== "Dependency Mapping" && (
        <>
        <div className={`wave-dropdown-alignment-${updatedData[0]?.value === AddtoProject ? "AddtoProject" : updatedData[0]?.value === CreatePOAA ? "CreatePOAA" : "RecreatePOA"}`}>
          <DropdownButton
            className="dropdown-button-custom"
            title={selectedWaveDetail?.Wave_Name || "Select"}
            align="end"
            onSelect={(e) => { 
              if (e === "Select") { 
                setWaveName("");
                setTPOAOwner("");
                setEstStartDate("");
                setEstAWPrinterDate("");
                setSelectedWaveDetail({});
                setSubmitWaveDetail({});
                setWaveNameError("Please select a valid wave.");
              } else {
                setWaveNameError("");
                handleWaveActionClick(e);
              }
            }}
            disabled={false}
          >
            <Dropdown.Item value="Select" eventKey="Select">
              Select
            </Dropdown.Item>
            {waveDetails?.map((item) => {
              return (
                <Dropdown.Item value={item?.Wave_ID} eventKey={item?.Wave_ID}>
                  {item?.Wave_Name}
                </Dropdown.Item>
              );
            })}
          </DropdownButton>
        </div>

        <Row className="fullkit-task-details">
          <Col>
            <Form.Group>
              <Form.Label>
                Wave Name <sup>*</sup>
              </Form.Label>
              <input
                id={`Wave_Name`}
                type="text"
                maxLength={textFieldMaxLengthWave}
                className="form-control font-size-10 taskValueInput"
                onChange={handleWaveNameChange}
                // treat null as "not yet edited" so we fall back to the selectedWaveDetail
                // but once the user has cleared the field we keep the empty string value
                value={
                  waveName !== null
                    ? waveName
                    : selectedWaveDetail?.Wave_Name || ""
                }
                disabled={false}
              />
              {waveNameError && (
                <span className="error-text-di">{waveNameError}</span>
              )}
              {<CharacterLimit field={waveName || selectedWaveDetail?.Wave_Name} maxLength={textFieldMaxLengthWave} />}
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>
                TPOA/POA Shell Creation Owner
              </Form.Label>
              <AutoComplete
                field="Person"
                disabled={false}
                id={`T_POA_Owner`}
                value={TPOAOwner || selectedWaveDetail?.T_POA_Owner || ""}
                forceSelection
                suggestions={filteredAssignees}
                completeMethod={completeSearchAssignee}
                onChange={(e) => {
                  setTPOAOwner(e.value);
                  setSubmitWaveDetail({...submitWaveDetail, T_POA_Owner: (e.target.value)?.Person});
                }}
                dropdown
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>
                Wave Start Date
              </Form.Label>
              <Calendar
                id={`Estimated_Start_Date`}
                disabled={false}
                minDate={new Date()}
                dateFormat="d-M-y"
                value={selectedWaveDetail?.Estimated_Start_Date
                      ? formatIntoDatePicker(changeDateFormat(selectedWaveDetail?.Estimated_Start_Date))
                      : EstStartDate}
                onChange={(e) => {
                  setEstStartDate(e.value);
                  setSubmitWaveDetail({...submitWaveDetail, Estimated_Start_Date: e.value});
                }}
                icon={<CalendarIcon />}
                showIcon={true}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>
                Estimated AW@Printer Date
              </Form.Label>
              <Calendar
                id={`Est_AW_Printer_Date`}
                disabled={false}
                minDate={new Date()}
                dateFormat="d-M-y"
                value={selectedWaveDetail?.Est_AW_Printer_Date
                      ? formatIntoDatePicker(changeDateFormat(selectedWaveDetail?.Est_AW_Printer_Date))
                      : EstAWPrinterDate}
                onChange={(e) => {
                  setEstAWPrinterDate(e.value);
                  setSubmitWaveDetail({...submitWaveDetail, Est_AW_Printer_Date: e.value});
                }}
                icon={<CalendarIcon />}
                showIcon={true}
              />
            </Form.Group>
          </Col>
        </Row>
        </>
      ))}
        
        <LoadingOverlay active={loader} spinner text="">
          <Row>
            {rowData ||
            (updatedData && updatedData[0]?.value === dsbpConstant.requestCICandCICMatrix) ? (
              <Col sm={12}>
                {selected && (
                  <DataTable
                    value={selected}
                    dataKey="id"
                    className="addToProjectTable"
                    emptyMessage={
                      (updatedData && updatedData[0]?.value) === dsbpConstant.requestCICandCICMatrix
                        ? dsbpConstant.fromActionFullkitNotReadyMessage
                        : dsbpConstant.fromActionNoPMPMessage
                    }
                    scrollable
                  >
                    <Column field="DSBP_PMP_PIMaterialNumber" header="PMP "></Column>
                    <Column
                      field="DSBP_PMP_PIMaterialDescription"
                      header="PMP Description"
                    ></Column>
                    {updatedData &&
                      updatedData[0]?.value === dsbpConstant.requestCICandCICMatrix && (
                        <Column field="AWM_CIC_Matrix" header="CIC/CIC Matrix"></Column>
                      )}
                  </DataTable>
                )}
              </Col>
            ) : (
              <>
                {updatedData &&
                  (updatedData[0]?.value === CreatePOAA ||
                    updatedData[0]?.value === RecreatePOA ||
                    updatedData[0]?.value === AddtoProject) &&
                  actionHeader !== "Dependency Mapping" && (
                    <Col sm={12}>
                      <div className="card">
                        {/* 2952 changes -show hte warnign message when owerns mismatch */}
                        {showOwnerErrorPopup && (
                          // Show error message when multiple owners are selected
                          <div className="invalid-pmp-message-container">
                            <img src={warning} alt="warning icon" />
                            <p className="invalid-pmp-message">{shellOwnerMistmach}</p>
                          </div>
                        )}
                        <>
                          {lockedData?.length > 0 && (
                            <>
                              <DataTable value={lockedData} dataKey="id" scrollable>
                                {poaColumns.map((col) => {
                                  if (
                                    (col.field === "RTA_POANumber" ||
                                      col.field === "RTA_POADescription") &&
                                    updatedData?.[0]?.value !== RecreatePOA
                                  ) {
                                    return null;
                                  }

                                  return (
                                    <Column
                                    key={col.field}
                                    field={col.field}
                                    header={col.header}
                                    className="poa-table"
                                    body={(rowData) => (
                                      <span title={rowData[col.field]}>
                                        {rowData[col.field]}
                                      </span>
                                    )}
                                  />       
                                  );
                                })}
                              </DataTable>
                              <p className="selected-count">{lockedData?.length} Selected </p>
                            </>
                          )}

                          {notLockedData?.length > 0 && (
                            <>
                              {" "}
                              <br />
                              <div className="invalid-pmp-message-container">
                                <img src={warning} alt="warning icon" />
                                <p className="invalid-pmp-message">
                                  {updatedData && updatedData[0]?.value === AddtoProject
                                    ? notLockedPMPMessage
                                    : updatedData && updatedData[0]?.value === RecreatePOA
                                    ? invalidRecreatePOAMessage
                                    : poaTriggeredMessage}
                                </p>
                              </div>
                              <DataTable value={notLockedData} dataKey="id" scrollable>
                              {poaColumns.map((col) => {
                                  if (
                                    (col.field === "RTA_POANumber" ||
                                      col.field === "RTA_POADescription") &&
                                    updatedData?.[0]?.value !== RecreatePOA
                                  ) {
                                    return null;
                                  }

                                  return (  
                                    <Column
                                    key={col.field}
                                    field={col.field}
                                    header={col.header}
                                    className="poa-table"
                                    body={(rowData) => (
                                      <span title={rowData[col.field]}>
                                        {rowData[col.field]}
                                      </span>
                                    )}
                                  />                                  
                                  );
                                })}
                              </DataTable>
                              <p className="selected-count">{notLockedData?.length} Selected </p>
                            </>
                          )}
                        </>
                      </div>
                    </Col>
                  )}

                {updatedData &&
                  (updatedData[0]?.value === "Group PMPs" ||
                    updatedData[0]?.value === MassUpdate) &&
                  actionHeader !== "Dependency Mapping" && (
                    <Col sm={7}>
                      {selected && (
                        <DataTable
                          value={selected}
                          dataKey="id"
                          emptyMessage={
                            updatedData &&
                            updatedData[0]?.value !== AddtoProject &&
                            "Either POA-A is already triggered for the selected PMP or PMP is not added to project"
                          }
                          scrollable
                        >
                          <Column field="DSBP_PMP_PIMaterialNumber" header="PMP "></Column>
                          <Column
                            field="DSBP_PMP_PIMaterialDescription"
                            header="PMP Description"
                          ></Column>
                        </DataTable>
                      )}
                    </Col>
                  )}
                <Col sm={4}>
                  {updatedData &&
                    updatedData[0]?.value === MassUpdate &&
                    (headerName !== "Dependency Mapping" ? (
                      <Row>
                        <Col sm={12}>
                          <Form.Group className={`mb-4`} controlId="groupName.ControlInput1">
                            <Form.Label>Assembly Mechanism</Form.Label>
                            <div>
                              <Form.Select
                                value={assemblyMechanismChange}
                                placeholder="Select Assembly Mechanism"
                                onChange={handleAssemblyMechanismChange}
                                disabled={addedToProjectRows.length === 0}
                              >
                                <option value="">Select Assembly Mechanism</option>
                                {assemblyMechanismList.map((aise) => (
                                  <option key={aise.code} value={aise.AWM_AssemblyMechanism}>
                                    {aise.AWM_AssemblyMechanism}
                                  </option>
                                ))}
                              </Form.Select>
                            </div>
                          </Form.Group>

                          <Form.Group
                            className={`mb-4`}
                            controlId="groupName.ControlInput1"
                            ref={dropdownRef}
                          >
                            <Form.Label>Shell Creation Owner</Form.Label>
                            {/* <div>
                              <Form.Select
                                value={ownerChange}
                                placeholder="Select Shell Creation Owner"
                                onChange={handleOwnerChange}
                                disabled={ownersList?.length === 0}
                              >
                                {ownerChange ? (
                                  <option value={ownerChange} hidden>
                                    {ownerChange}
                                  </option>
                                ) : (
                                  <option value="" hidden>
                                    Select Shell Creation Owner
                                  </option>
                                )}
                                {ownersList?.map((data) => (
                                  <option key={data?.Person} value={data?.Person}>
                                    {data?.Person}
                                  </option>
                                ))}
                              </Form.Select>
                            </div> */}
                            <CommonAutocomplete
                              width={width}
                              suggestions={ownersList}
                              value={ownerChange}
                              onChange={(e) => handleOwnerChange(e)}
                              placeholder="Select Shell Owner"
                              field="Person"
                              disabled={ownersList?.length === 0 || addedToProjectRows.length === 0}
                              className={
                                (ownersList?.length === 0 || addedToProjectRows.length === 0) &&
                                "massOwnerFieldDisabled"
                              }
                            />{" "}
                            {ownerMisMatch && <div> No results found </div>}
                          </Form.Group>
                        </Col>
                        {projectData?.BU === "Home Care" && (
                          <>
                            <Col sm={12}>
                              <Form.Group className={`mb-4`} controlId="groupName.ControlInput1">
                                <Form.Label>AISE</Form.Label>
                                <Form.Select
                                  value={aiseName}
                                  placeholder="Select AISE"
                                  onChange={handleAiseChange}
                                  disabled={addedToProjectRows.length === 0}
                                >
                                  <option value="">Select AISE</option>
                                  {aiseList.map((aise) => (
                                    <option key={aise.code} value={aise.AWM_AISE}>
                                      {aise.AWM_AISE}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                            </Col>
                            <Col sm={12}>
                              <Form.Group className={`mb-4`} controlId="groupName.ControlInput1">
                                <Form.Label>Biocide</Form.Label>
                                <div>
                                  <Form.Select
                                    value={bioside}
                                    placeholder="Select Biocide"
                                    onChange={handleBiosideChange}
                                    disabled={addedToProjectRows.length === 0}
                                  >
                                    <option value="">Select Biocide</option>
                                    {optionsList.map((data) => (
                                      <option key={data.code} value={data.name}>
                                        {data.name}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </div>
                              </Form.Group>
                            </Col>
                            <Col sm={12}>
                              <Form.Group className={`mb-4`} controlId="groupName.ControlInput1">
                                <Form.Label>Sellable</Form.Label>
                                <div>
                                  <Form.Select
                                    value={sellable}
                                    placeholder="Select Sellable"
                                    onChange={handleSellableChange}
                                    disabled={addedToProjectRows.length === 0}
                                  >
                                    <option value="">Select Sellable</option>
                                    {optionsList.map((data) => (
                                      <option key={data.code} value={data.name}>
                                        {data.name}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </div>
                              </Form.Group>
                            </Col>
                          </>
                        )}
                      </Row>
                    ) : (
                      <Row>
                        {RDTData && RDTData?.length && (
                          <Col sm={12}>
                            <Form.Group className={`mb-4`} controlId="groupName.ControlInput1">
                              <Form.Label>Regional Design Template</Form.Label>
                              <div>
                                <MultiSelect
                                  value={RDT}
                                  onChange={(e) => {
                                    updateDropDownData(e.value, "AWM_RDT_Page");
                                    setRDT(e.value);
                                    setFormData({
                                      ...formData,
                                      AWM_RDT_Page: e.target.value,
                                    });
                                  }}
                                  options={
                                    RDTData
                                      ? RDTData.map((obj) => ({
                                          label: obj.AWM_Design_Job_Name,
                                          value: obj.AWM_Design_Job_ID,
                                          disabled:
                                            (RDT.length &&
                                              RDT.includes("DT_DJobN/A") &&
                                              obj.AWM_Design_Job_ID !== "DT_DJobN/A") ||
                                            (RDT.length &&
                                              !RDT.includes("DT_DJobN/A") &&
                                              obj.AWM_Design_Job_ID === "DT_DJobN/A"),
                                        })).filter((option) => option.label !== "")
                                      : []
                                  }
                                  filter
                                  display="chip"
                                  placeholder={`Select`}
                                  maxSelectedLabels={3}
                                  className="p-column-filter"
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        )}
                        {CDPTPageData && CDPTPageData?.length && (
                          <Col sm={12}>
                            <Form.Group className={`mb-4`} controlId="groupName.ControlInput1">
                              <Form.Label>Color Development and Print Trial</Form.Label>
                              <div>
                                <MultiSelect
                                  value={CDPT}
                                  onChange={(e) => {
                                    updateDropDownData(e.value, "AWM_CDPT_Page");
                                    setCDPT(e.value);
                                    setFormData({
                                      ...formData,
                                      AWM_CDPT_Page: e.target.value,
                                    });
                                  }}
                                  options={
                                    CDPTPageData
                                      ? CDPTPageData.map((obj) => ({
                                          label: obj.AWM_Design_Job_Name,
                                          value: obj.AWM_Design_Job_ID,
                                          disabled:
                                            (CDPT.length &&
                                              CDPT.includes("NPF_DJobN/A") &&
                                              obj.AWM_Design_Job_ID !== "NPF_DJobN/A") ||
                                            (CDPT.length &&
                                              !CDPT.includes("NPF_DJobN/A") &&
                                              obj.AWM_Design_Job_ID === "NPF_DJobN/A"),
                                        })).filter((option) => option.label !== "") // Filter out options with empty labels
                                      : []
                                  }
                                  filter
                                  display="chip"
                                  placeholder={`Select`}
                                  maxSelectedLabels={3}
                                  className="p-column-filter"
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        )}
                        {IQData?.length && (
                          <Col sm={12}>
                            <Form.Group className={`mb-4`} controlId="groupName.ControlInput1">
                              <Form.Label>Ink Qualification</Form.Label>
                              <div>
                                <MultiSelect
                                  value={IQ}
                                  onChange={(e) => {
                                    updateDropDownData(e.value, "AWM_IQ_Page");
                                    setIQ(e.value);
                                    setFormData({
                                      ...formData,
                                      AWM_IQ_Page: e.target.value,
                                    });
                                  }}
                                  options={
                                    IQData
                                      ? IQData.map((obj) => ({
                                          label: obj.AWM_Design_Job_Name,
                                          value: obj.AWM_Design_Job_ID,
                                          disabled:
                                            (IQ.length &&
                                              IQ.includes("IQ_DJobN/A") &&
                                              obj.AWM_Design_Job_ID !== "IQ_DJobN/A") ||
                                            (IQ.length &&
                                              !IQ.includes("IQ_DJobN/A") &&
                                              obj.AWM_Design_Job_ID === "IQ_DJobN/A"),
                                        })).filter((option) => option.label !== "")
                                      : []
                                  }
                                  filter
                                  display="chip"
                                  placeholder={`Select`}
                                  maxSelectedLabels={3}
                                  className="p-column-filter"
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        )}
                        {GABriefData && projectData?.CICs && (
                          <Col sm={12}>
                            <Form.Group className={`mb-4`} controlId="groupName.ControlInput1">
                              <Form.Label>{dsbpConstant?.GA_BRIEF}</Form.Label>
                              <div>
                                <Form.Select
                                  value={GABrief}
                                  placeholder="Select"
                                  onChange={(e) => {
                                    updateDropDownData(e.target.value, "AWM_GA_Brief");
                                    setGABrief(e.target.value);
                                    setFormData({
                                      ...formData,
                                      AWM_GA_Brief: e.target.value,
                                    });
                                  }}
                                >
                                  <option value="">Select</option>

                                  {GABriefData?.map(
                                    (data, index) =>
                                      data.File_Name !== "Add GA Brief" && (
                                        <option
                                          key={`${data.File_Name}_${index}`}
                                          value={data.File_Name}
                                        >
                                          {data.File_Name}
                                        </option>
                                      )
                                  )}
                                </Form.Select>
                              </div>
                            </Form.Group>
                          </Col>
                        )}
                      </Row>
                    ))}
                  {updatedData && updatedData[0]?.value === "Group PMPs" && (
                    <Form.Group className={`mb-4`} controlId="groupName.ControlInput1">
                      <Form.Label>
                        Group Name<sup>*</sup>
                      </Form.Label>
                      <input
                        type="text"
                        className={
                          groupName?.length === 0
                            ? "form-control"
                            : groupName?.length >= textFieldMaxLength
                            ? "form-control"
                            : "form-control border-success"
                        }
                        placeholder="Enter Group Name"
                        onChange={handleGroupName}
                        maxLength={textFieldMaxLength}
                        value={groupName}
                        disabled={addedToProjectRows.length === 0}
                      />
                      <div className="col-9">
                        <CharacterLimit field={groupName} maxLength={textFieldMaxLength} />
                      </div>
                    </Form.Group>
                  )}
                  {/* {updatedData && updatedData[0]?.value === CreatePOAA && (
                    <Form.Group className={`mb-4`} controlId="groupName.ControlInput1">
                      <Form.Label>Package Name</Form.Label>
                      <input
                        type="text"
                        maxLength={255}
                        className="form-control"
                        placeholder="Enter Package Name"
                        onChange={handlePackageName}
                        value={packageName}
                        disabled={lockedData.length === 0}
                      />
                    </Form.Group>
                  )} */}
                  {updatedData && updatedData[0]?.value === "Group items into CIC Matrix" && (
                    <Form.Group className={`mb-4`} controlId="groupName.ControlInput1">
                      <Form.Label>
                        CIC Matrix Name<sup>*</sup>
                      </Form.Label>
                      <input
                        type="text"
                        maxLength={255}
                        className="form-control"
                        placeholder="Enter CIC Matrix Name"
                        onChange={handleCicMatrixName}
                        value={cicMatrixName}
                        disabled={selected.length === 0}
                      />
                      <CharacterLimit field={cicMatrixName} maxLength={255} />
                      {groupNameError && groupNameError.length && (
                        <div className="group-name-error">{groupNameError}</div>
                      )}
                    </Form.Group>
                  )}
                </Col>
                {updatedData &&
                  updatedData[0]?.value === MassCICMapping&&
                  actionHeader !== "Dependency Mapping" && (
                    <div className="cicMassUpdate">
                      <Row>
                        <MassUpdateCICMappingTable
                          validPmpsSelected={validPmpsSelected}
                          invalidPmpsSelected={invalidPmpsSelected}
                          invalidPmpMessage={invalidPmpMessage}
                        />
                        <Col sm={4}>
                          <Form.Group className={`mb-4`} controlId="groupName.ControlInput1">
                            <Form.Label className="mucm-label">
                              {dsbpConstant?.CIC_NEEDED}
                            </Form.Label>
                            <Form.Select
                              value={cicNeeded}
                              onChange={handleCICMassUpdate}
                              disabled={!validPmpsSelected?.length}
                              placeholder="Select"
                              name="cicNeeded"
                            >
                              <option className="hidden-option" value="" default selected>
                                Select...
                              </option>
                              {optionArray?.map((data) => (
                                <option key={data.code} value={data.code}>
                                  {data.name}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                          <Form.Group className={`mb-4`} controlId="groupName.ControlInput1">
                            <Form.Label className="mucm-label">
                              {dsbpConstant?.SUPPORTING_PMP_LAYOUT}
                            </Form.Label>
                            <Form.Select
                              value={supportingPMPLayout}
                              onChange={handleCICMassUpdate}
                              disabled={
                                cicNeeded === YES ||
                                cicNeeded === NOT_NEEDED ||
                                cicNeeded === "" ||
                                !validPmpsSelected?.length
                              }
                              placeholder="Select"
                              name="supportingPMPLayout"
                              className={
                                cicNeeded === CIC_DEPENDENT &&
                                (supportingPMPDesign === "" || supportingPMPDesign === NULL) &&
                                (supportingPMPLayout === "" || supportingPMPLayout === NULL) &&
                                otherReference === ""
                                  ? "border-red"
                                  : "border-normal"
                              }
                            >
                              <option className="hidden-option" value={NULL} default selected>
                                Select...
                              </option>
                              <option value="">Select</option>
                              {updatedDropdownDataForLayoutAndDesign?.map((data) => (
                                <option key={data.code} value={data}>
                                  {data}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                          <Form.Group className={`mb-4`} controlId="groupName.ControlInput1">
                            <Form.Label className="mucm-label">
                              {dsbpConstant?.SUPPORTING_PMP_DESIGN}
                            </Form.Label>
                            <Form.Select
                              value={supportingPMPDesign}
                              onChange={handleCICMassUpdate}
                              disabled={
                                cicNeeded === YES ||
                                cicNeeded === NOT_NEEDED ||
                                cicNeeded === "" ||
                                !validPmpsSelected?.length
                              }
                              placeholder="Select"
                              name="supportingPMPDesign"
                              className={
                                cicNeeded === CIC_DEPENDENT &&
                                (supportingPMPDesign === "" || supportingPMPDesign === NULL) &&
                                (supportingPMPLayout === "" || supportingPMPLayout === NULL) &&
                                otherReference === ""
                                  ? "border-red"
                                  : "border-normal"
                              }
                            >
                              <option className="hidden-option" value={NULL} default selected>
                                Select...
                              </option>
                              <option value="">Select</option>
                              {updatedDropdownDataForLayoutAndDesign?.map((data) => (
                                <option key={data.code} value={data}>
                                  {data}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                          <Form.Group className={`mb-4`} controlId="groupName.ControlInput1">
                            <Form.Label className="mucm-label">
                              {dsbpConstant?.OTHER_REFERENCE}
                            </Form.Label>
                            <input
                              type="text"
                              maxLength={8}
                              onChange={(e) => {
                                e.target.value = e.target.value.replace(/[^0-9]/g, ""); // only numbers
                                handleCICMassUpdate(e);
                              }}
                              value={otherReference}
                              disabled={!validPmpsSelected?.length || cicNeeded === ""}
                              name="otherReference"
                              className={`form-control 
                          ${
                            cicNeeded === CIC_DEPENDENT &&
                            (supportingPMPDesign === "" || supportingPMPDesign === NULL) &&
                            (supportingPMPLayout === "" || supportingPMPLayout === NULL) &&
                            otherReference === ""
                              ? "border-red"
                              : "border-normal"
                          }
                        `}
                            />
                            {otherReference?.length < 8 && otherReference?.length !== 0 && (
                              <div className="invalid-pmp-error">Valid PMP# is 8 digits</div>
                            )}
                          </Form.Group>
                          <Form.Group className={`mb-4`} controlId="groupName.ControlInput1">
                            <Form.Label className="mucm-label">{dsbpConstant?.GA_BRIEF}</Form.Label>
                            <Form.Select
                              value={gaBrief}
                              onChange={handleCICMassUpdate}
                              disabled={!validPmpsSelected?.length}
                              placeholder="Select"
                              name="gaBrief"
                              className="form-control"
                              title={gaBrief?.length > 50 && gaBrief}
                            >
                              <option className="hidden-option" value="" default selected>
                                Select...
                              </option>
                              {GABriefData?.map(
                                (data, index) =>
                                  data.File_Name !== "Add GA Brief" && (
                                    <option
                                      key={`${data.File_Name}_${index}`}
                                      value={data.File_Name}
                                      title={data.File_Name}
                                    >
                                      {
                                        truncateDropdownValues(
                                          data.File_Name
                                        ) /*truncate the dropdown value if the text lenght mroe than 50 } */
                                      }
                                    </option>
                                  )
                              )}
                            </Form.Select>
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                  )}
              </>
            )}
          </Row>
        </LoadingOverlay>
      </Dialog>
    </div>
  );
};
export default DsbpActionDialog;
